import { render, staticRenderFns } from "./internalunit.vue?vue&type=template&id=38a2f849&scoped=true"
import script from "./internalunit.vue?vue&type=script&lang=js"
export * from "./internalunit.vue?vue&type=script&lang=js"
import style0 from "./internalunit.vue?vue&type=style&index=0&id=38a2f849&prod&lang=scss&scoped=true"
import style1 from "./internalunit.vue?vue&type=style&index=1&id=38a2f849&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a2f849",
  null
  
)

export default component.exports